var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input"},[_c('Autocomplete',{attrs:{"size":"medium","value":_vm.value,"debounce":300,"disabled":_vm._disabled,"fetch-suggestions":_vm.getOptions},on:{"input":_vm.update}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }